<template>
<div>

    <v-icon 
            
        v-on:click="onEdit"
        color="primary"
        style="pointer-events: auto;"
        v-if="menu_items.length == 0"
    >
        mdi-lead-pencil
    </v-icon>

        
    <v-menu 
        bottom 
        offset-y  
        v-if="menu_items.length != 0"
    >

            <template v-slot:activator="{ on }">
                

                <v-icon
                    v-on="on"
                    color="primary"
                    style="pointer-events: auto;"
                    v-if="!as_btn"
                >
                    mdi-dots-vertical
                </v-icon>

                <v-btn
                    v-if="as_btn"
                >
                    <v-icon
                        v-on="on"
                        style="pointer-events: auto;"
                        v-if="as_btn"
                    >
                        mdi-menu
                    </v-icon>
                </v-btn>
                
            </template>

            <v-list>
                <div
                    v-for="(item, index) in menu_items"
                        :key="index"
                >
                    <v-list-item
                        v-if="!isSeparator(item)"
                        v-on:click="onClickMenuItem(item)"
                    >
                        <v-list-item-title>{{item.text}}</v-list-item-title>
                    </v-list-item>
                    <v-divider
                        v-if="isSeparator(item)"
                    />
                </div>
                    
            </v-list>

        </v-menu>
</div>
</template>

<script>
export default {

    props: {
        as_btn : {
            type: Boolean,
            default: function () { return false; }
        },

        menu_items: {
            type: Array,
            default: function () { return []; } 
        },
    },

    methods: {

        onEdit() 
        {
            this.$emit('menu-action', {
                'text' : 'Edit',
                'event' : 'edit'
            });    
        },

        onClickMenuItem(item)
        {
            this.$emit('menu-action', item);  
        },

        isSeparator(menu_item)
        {
            return menu_item.separator == true || menu_item.separator == 'true'; 
            
        },

    },
}
</script>

<style lang="scss" scoped>

</style>